import {
  createDefaultMaskGenerator,
  getCurrencyMaskGenerator,
  mask,
} from "react-hook-mask";

import { i18n } from "@/i18n";

export const phoneNumberMask = createDefaultMaskGenerator("(999) 999-9999");

export const getMaskedPhoneNumber = (value: string): string => {
  return mask(value, phoneNumberMask);
};

export const ssnMask = createDefaultMaskGenerator("999-99-9999");

export const getMaskedSsn = (value: string): string => {
  return mask(value, ssnMask);
};

export const handlePossessiveApostrophe = (name: string): string => {
  if (!name) return "";

  if (i18n.language !== "en") {
    return name;
  }

  const lastChar = name.charAt(name.length - 1).toLowerCase();
  if (lastChar === "s") {
    return `${name}'`;
  }
  return `${name}'s`;
};

export const currencyMask = getCurrencyMaskGenerator({
  prefix: "",
  thousandSeparator: ",",
});

export const getMaskedCurrency = (value: string): string => {
  return mask(value, currencyMask);
};

// Helper function to convert string to number for currency fields
export const convertStringToNumber = (
  value: string | null | undefined,
): number | null => {
  if (!value) {
    return null;
  }
  const sanitizedValue = value.replace(/,/g, "");
  const numericValue = Number(sanitizedValue);
  return !isNaN(numericValue) ? numericValue : null;
};
